import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import * as fromCommonStore from '../../store';
import * as fromRootStore from '../../reducers';

import { clientOutService, SubscribeService, CommonService, SalesBillentryService, UnsoldDescriptionService, PovConfigService } from '../../services/index';
import { clientOutModel, FollowUpModel, FollowUpStatus } from '../../model/index';


@Component({
    selector: 'clientOut-tab',
    templateUrl: './clientOut.component.html'
})

export class clientOutComponent implements OnInit {
    @ViewChild('imageFile') imageFileRef: ElementRef;
    isLoadMask: Promise<any>;
    loadingIndicator: boolean = true;
    statusCtrl: FormControl;
    assignToCtrl: FormControl;
    assignToList: any[];
    followUpStatusList: any[];
    followUpHVList: any[];
    employeeCtrl: FormControl;
    employeeList: any[] = [];
    filteredEmployee: Observable<any[]>;
    private searchTermsEmployee = new Subject<string>();
    private _clientStatus: any = [];
    get clientStatus(): any { return this._clientStatus; }
    set clientStatus(val: any) {
        this._clientStatus = val;
        // apply POV filter now that clientStatus is set (followUpHVList may already be loaded)
        if (this.followUpHVList && this.followUpHVList.length) {
            this.applyPovFilter();
        }
    }
    @Output() clientOutLoadEvent = new EventEmitter();
    isLoading: boolean = false;
    subscribeFolStatus;
    uploadedImageName: string = '';
    uploadedImageFile: any = null;
    unsoldDescriptionList: any[] = [];

    // Dropdown options for each field
    telecareAppOptions = [
        { value: 'No', label: 'No' },
        { value: 'Yes', label: 'Yes' }
    ];
    rocCouponOptions = [
        { value: 'No', label: 'No' },
        { value: 'Yes', label: 'Yes' }
    ];
    rocReferralOptions = [
        { value: 'No', label: 'No' },
        { value: 'Yes', label: 'Yes' }
    ];
    googleReviewOptions = [
        { value: 'No', label: 'No' },
        { value: 'Yes', label: 'Yes' }
    ];
    testimonialOptions = [
        { value: 'No', label: 'No' },
        { value: 'Yes', label: 'Yes' }
    ];
    contactNumberSavedOptions = [
        { value: 'No', label: 'No' },
        { value: 'Yes', label: 'Yes' }
    ];

    constructor(public store: Store<fromRootStore.State>, public toasterService: ToasterService, public clientOutService: clientOutService, public commonService: CommonService, public bsModalRef: BsModalRef, public subscribeService: SubscribeService, public salesBillEntryService: SalesBillentryService, public unsoldDescriptionService: UnsoldDescriptionService, public povConfigService: PovConfigService) {
        // Employee validation function
        function hasValidEmployee(input: FormControl) {
            let empID = input.value, retVal = null;
            if (empID && !isNaN(empID) && empID > 0) {
                return null; // Valid employee ID
            } else if (empID && (isNaN(empID) || empID <= 0)) {
                retVal = { inValidEmployee: true };
            }
            return retVal;
        }

        // Initialize employee form control - not required by default, validation handled conditionally in save
        this.employeeCtrl = new FormControl('', [hasValidEmployee.bind(this)]);

        // Setup employee search functionality
        let that = this;
        this.filteredEmployee = this.searchTermsEmployee
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => term
                ? this.commonService.getEmployeeList(term, 'challan')
                : Observable.of<any[]>([]))
            .catch(error => {
                console.log(error);
                return Observable.of<any[]>([]);
            });
        this.filteredEmployee.subscribe(($e) => {
            that.employeeList = $e;
        });
    }

    ngOnInit(): void {
        this.unsoldDescriptionService.getActiveUnsoldDescriptionList().then((res: any) => {
            if (res && res.data) {
                this.unsoldDescriptionList = res.data;
            }
        });

        this.subscribeFolStatus = this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.followUpHVList = res.data;
            this.followUpStatusList = _.filter(res.data, function (obj) { return obj['is_clientout'] == 'Yes' });
            this.applyPovFilter();
        });

        //FOR AUTO COMPLETE VALIDATION --- ASSIGN TO LIST
        function hasValidAssignto(input: FormControl) {
            let statusID = input.value, retVal = null;
            if (statusID == "") {
                retVal = { inValidAssignTo: true };
            }
            if (statusID && typeof statusID === 'string') {
                retVal = { inValidAssignTo: true };
            }
            return retVal;
        }
        this.assignToCtrl = new FormControl('', [
            Validators.required,
            hasValidAssignto.bind(this)
        ]);
        setTimeout(() => {
            if (this.clientStatus && (this.clientStatus['tabParams'] == 'HV Appointment' || this.clientStatus['tabParams'] == 'SOA Appointment')) {
                this.followUpStatusList = _.filter(this.followUpHVList, function (obj) { return obj['appointment_out_status'] == 'Yes' });
            }

            // Initialize uploaded image name if exists in clientStatus
            if (this.clientStatus && this.clientStatus['uploaded_image']) {
                this.uploadedImageName = this.clientStatus['uploaded_image'];
            }

            // Initialize mandatory fields with default values if not set
            if (!this.clientStatus['telecare_app_installed']) {
                this.clientStatus['telecare_app_installed'] = '';
            }
            if (!this.clientStatus['roc_coupon_give']) {
                this.clientStatus['roc_coupon_give'] = '';
            }
            if (!this.clientStatus['google_review']) {
                this.clientStatus['google_review'] = '';
            }
            if (!this.clientStatus['roc_referral']) {
                this.clientStatus['roc_referral'] = '';
            }
            if (!this.clientStatus['testimonial']) {
                this.clientStatus['testimonial'] = '';
            }
            if (!this.clientStatus['contact_number_saved']) {
                this.clientStatus['contact_number_saved'] = '';
            }
            if (!this.clientStatus['roc_employee_id']) {
                this.clientStatus['roc_employee_id'] = '';
            }
            if (!this.clientStatus['unsold_description_id']) {
                this.clientStatus['unsold_description_id'] = '';
            }
            if (!this.clientStatus['unsold_reason_details']) {
                this.clientStatus['unsold_reason_details'] = '';
            }
        }, 100);
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        this.subscribeFolStatus.unsubscribe();
    }

    applyPovFilter() {
        let that = this;
        if (!this.followUpHVList || !this.followUpHVList.length) { return; }
        if (this._clientStatus['tabParams'] === 'HV Appointment' || this._clientStatus['tabParams'] === 'SOA Appointment') { return; }
        // pov column only set on new records — old records show all is_clientout='Yes' statuses unchanged
        let pov = this._clientStatus['pov'] || '';
        if (!pov) { return; }
        let normalizedPov = pov.split(',').map(s => s.trim()).filter(Boolean).sort().join(',');
        this.povConfigService.getByPov({ pov_name: normalizedPov }).then(function (configRes: any) {
            if (configRes && configRes.success && configRes.data && configRes.data.out_status_fol_ids_arr && configRes.data.out_status_fol_ids_arr.length) {
                let allowed = configRes.data.out_status_fol_ids_arr.map(Number);
                that.followUpStatusList = _.filter(that.followUpHVList, function (obj) {
                    return obj['is_clientout'] === 'Yes' && allowed.indexOf(Number(obj['fol_id'])) !== -1;
                });
            }
        });
    }

    statusChanged() {
        let that = this;
        that.clientStatus['assign_empid'] = "";
        if (this.clientStatus['followup_status'] != "") {
            let data = {
                fol_id: this.clientStatus['followup_status']
            };

            that.commonService
                .getUserList(data)
                .then(function (res: any) {
                    that.assignToList = res.data;
                });
        }
    }
    assignFn(empid: any) {
        if (this.assignToList != undefined) {
            if (empid && this.assignToList.length > 0) {
                let fitem = _.find(this.assignToList, { 'userid': empid });
                return fitem['fullname'];
            }
        }
        return '';
    }


    goToServicewalkin(row: any): void {
        row['mode'] = 'Add';
        row['from_page'] = 'outstatus_company_service';
        row['walk_in_type'] = 'Service';
        this.subscribeService.subScribeTabID('Transaction', 'AddServiceWalkInComponent', row, 'Service Walk-in');
        this.bsModalRef.hide();
    }

    goToServiceBill(row: any): void {
        let that = this,
            data = {
                client_id: row['client_id'],
                outType: 'ServiceBill'
            }

        this.commonService.getExistServiceClient(data).then(function (res: any) {
            console.log("response", res.data);
            if (res.data.length > 0) {
                let seriesparam = res.data[0];
                seriesparam['mode'] = 'Edit';
                seriesparam['from_page'] = 'Service Walk-in';
                seriesparam['view_type'] = 'Bill';
                seriesparam['hvoutstaus'] = 'yes';
                seriesparam['ha_id'] = row['ha_id'];
                that.subscribeService.subScribeTabID('Transaction', 'AddBillEntryComponent', Object.assign({}, seriesparam), 'billEntry');
                that.bsModalRef.hide();
            }
            else {
                swal('Error', 'Service Bill is not Available for this Cient');
                return;
            }
        })


    }
    uploadImage($event): void {
        const file = $event.target.files[0];
        if (!file) return;

        const maxSize = 2 * 1024 * 1024; // 2MB
        const validExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
        const ext = file.name.split('.').pop().toLowerCase();

        if (file.size > maxSize) {
            swal('ERROR', 'File size is too big! Maximum size is 2MB.', 'error');
            return;
        }

        if (!file.type.startsWith('image/') && !validExtensions.includes(ext)) {
            swal('ERROR', 'Please select a valid image file.', 'error');
            return;
        }

        this.uploadedImageFile = file;
        this.uploadedImageName = file.name;
    }

    onSaveClientOut(): void {
        let that = this;
        let toast = {
            type: 'warning',
            title: 'WARNING'
        };

        if (this.clientStatus['followup_status'] == 0) {
            toast['body'] = 'Please Select Valid Status';
            this.toasterService.pop(toast);
            return;
        }
        if (this.clientStatus['followup_status'] == 35 &&
            (!this.clientStatus['unsold_description_id'] ||
                !this.clientStatus['assign_empid'])) {
            toast['body'] = 'Please Select Unsold Remarks && Assign To';
            this.toasterService.pop(toast);
            return;
        }

        if (this.clientStatus['followup_status'] == 5 &&
            (!this.clientStatus['unsold_description_id'] ||
                !this.clientStatus['assign_empid'])) {
            toast['body'] = 'Please Select Unsold Remarks && Assign To';
            this.toasterService.pop(toast);
            return;
        }

        if (this.clientStatus['unsold_description_id']) {
            let selectedDesc = this.unsoldDescriptionList.find(d => d.id == this.clientStatus['unsold_description_id']);
            if (selectedDesc) {
                this.clientStatus['remarks'] = selectedDesc.name;
            }
        }

        // Validate mandatory fields
        if (!this.clientStatus['telecare_app_installed']) {
            toast['body'] = 'Please select Telecare app installed';
            this.toasterService.pop(toast);
            return;
        }
        if (!this.clientStatus['roc_coupon_give']) {
            toast['body'] = 'Please select Roc coupon give';
            this.toasterService.pop(toast);
            return;
        }
        if (!this.clientStatus['google_review']) {
            toast['body'] = 'Please select Google review';
            this.toasterService.pop(toast);
            return;
        }
        if (!this.clientStatus['roc_referral']) {
            toast['body'] = 'Please select Roc referral';
            this.toasterService.pop(toast);
            return;
        }
        if (!this.clientStatus['testimonial']) {
            toast['body'] = 'Please select Testimonial';
            this.toasterService.pop(toast);
            return;
        }
        if (!this.clientStatus['contact_number_saved']) {
            toast['body'] = 'Please select Contact number saved';
            this.toasterService.pop(toast);
            return;
        }
        // Validate employee field if ROC Coupon Give is Yes
        if (this.clientStatus['roc_coupon_give'] === 'Yes' && !this.clientStatus['roc_employee_id']) {
            toast['body'] = 'Please select Employee when ROC Coupon Give is Yes';
            this.toasterService.pop(toast);
            return;
        }
        if (that.clientStatus['followup_status'] == '4' && (this.clientStatus['tabParams'] != 'HV Appointment' && this.clientStatus['tabParams'] != 'SOA Appointment')) { //redirect to sales bill entry page
            that.clientStatus['mode'] = 'Add';
            that.clientStatus['description'] = '';
            that.clientStatus['walkin_id'] = that.clientStatus['walkin_id'] || 0;
            // var client_id = this.clientStatus["client_id"];
            let data = {
                client_id: this.clientStatus["client_id"]
            };
            that.salesBillEntryService.getExistAdvClient(data).then(function (res: any) {
                //that.clientList = res;
                if (res.totCnt > 0) {
                    that.clientStatus['adv_bill_id'] = res.data[0].adv_bill_id;
                    //that.salesbillentrydata['bill_type'] = res.data[0].bill_type;
                    that.clientStatus['bill_id'] = res.data[0].adv_bill_id;

                    // that.salesbillentrydata['discount_percentage'] = res.data[0].discount_percentage;
                    // that.salesbillentrydata['discount_amount'] = res.data[0].discount_amount;
                    that.clientStatus['initial_amount'] = res.data[0].initial_amount;
                    if (that.clientStatus['tabParams'] != "Advance") {
                        that.clientStatus['advances'] = res.data[0].oldadvances;
                    }
                    if (that.clientStatus['tabParams'] == 'Advance') {
                        that.clientStatus['oldadvances'] = res.data[0].oldadvances;
                        that.clientStatus['gross_total'] = res.data[0].gross_total;
                        that.clientStatus['amount'] = res.data[0].amount;
                        that.clientStatus['less_amount'] = res.data[0].less_amount;
                        //that.getSalesbillentryDetailList();
                        that.clientStatus['hide_col'] = true;
                    }
                    if (that.clientStatus['tabParams'] == 'HV Entry') {
                        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'HV');
                    }
                    else if (that.clientStatus['tabParams'] == 'SOA Entry') {
                        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'SOA');
                    } else {
                        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'Sales Bill');
                    }
                }
                else {
                    if (that.clientStatus['tabParams'] == 'HV Entry') {
                        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'HV');
                    }
                    else if (that.clientStatus['tabParams'] == 'SOA Entry') {
                        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'SOA');
                    } else {
                        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'Sales Bill');
                    }
                }
            });
            that.bsModalRef.hide();
        }
        else if (that.clientStatus['followup_status'] == '83' && ((that.clientStatus['tabParams'] == 'HV Entry' || that.clientStatus['tabParams'] == 'SOA Entry' || that.clientStatus['tabParams'] == 'Out-Status-Edit' || that.clientStatus['tabParams'] == 'Client Walk-in' || that.clientStatus['tabParams'] == 'HV Appointment' || that.clientStatus['tabParams'] == 'SOA Appointment' || that.clientStatus['tabParams'] == 'DR Promo' || that.clientStatus['tabParams'] == 'SG Promo' || that.clientStatus['tabParams'] == 'Store Promo'))) { //redirect to pre booking bill entry page
            that.clientStatus['mode'] = 'Add';
            that.clientStatus['description'] = '';
            that.clientStatus['walkin_id'] = that.clientStatus['walkin_id'] || 0;
            // Add uploaded file reference to clientStatus for component navigation
            if (this.uploadedImageFile) {
                that.clientStatus['_uploadedFile'] = this.uploadedImageFile;
            }
            that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'Advance');
            that.bsModalRef.hide();
        } else if ((this.clientStatus['tabParams'] == 'HV Appointment' || this.clientStatus['tabParams'] == 'SOA Appointment' || this.clientStatus['tabParams'] == 'HV Entry' || this.clientStatus['tabParams'] == 'SOA Entry') && (that.clientStatus['followup_status'] == '87' || that.clientStatus['followup_status'] == '88')) {
            this.goToServicewalkin(this.clientStatus);
        }
        else if ((this.clientStatus['tabParams'] == 'HV Appointment' || this.clientStatus['tabParams'] == 'SOA Appointment') && that.clientStatus['followup_status'] == '85') {
            this.goToServiceBill(this.clientStatus);
        }
        // THIS CODE IS EXECUTED FOR HV TESTING ONLY
        else if (this.clientStatus['followup_status'] == 8 && this.clientStatus['tabParams'] == 'HV Appointment') {
            let data = this.clientStatus;
            data["mode"] = "HVEdit";
            this.subscribeService.subScribeTabID('Transaction', 'AddEditTestingBillComponent', data, this['tabParams']);
            that.bsModalRef.hide();
        } else if (that.clientStatus['followup_status'] == '4' && (this.clientStatus['tabParams'] == 'HV Appointment' || this.clientStatus['tabParams'] == 'SOA Appointment')) {
            //redirect to HV/SOA sales bill entry page
            that.clientStatus['mode'] = 'Add';
            that.clientStatus['description'] = '';
            that.clientStatus['walkin_id'] = that.clientStatus['walkin_id'] || 0;
            // var client_id = this.clientStatus["client_id"];
            let data = {
                client_id: this.clientStatus["client_id"]
            };
            that.salesBillEntryService.getExistAdvClient(data).then(function (res: any) {
                //that.clientList = res;
                if (res.totCnt > 0) {
                    that.clientStatus['adv_bill_id'] = res.data[0].adv_bill_id;
                    //that.salesbillentrydata['bill_type'] = res.data[0].bill_type;
                    that.clientStatus['bill_id'] = res.data[0].adv_bill_id;

                    // that.salesbillentrydata['discount_percentage'] = res.data[0].discount_percentage;
                    // that.salesbillentrydata['discount_amount'] = res.data[0].discount_amount;
                    that.clientStatus['initial_amount'] = res.data[0].initial_amount;
                    if (that.clientStatus['tabParams'] != "Advance") {
                        that.clientStatus['advances'] = res.data[0].oldadvances;
                    }
                    if (that.clientStatus['tabParams'] == 'Advance') {
                        that.clientStatus['oldadvances'] = res.data[0].oldadvances;
                        that.clientStatus['gross_total'] = res.data[0].gross_total;
                        that.clientStatus['amount'] = res.data[0].amount;
                        that.clientStatus['less_amount'] = res.data[0].less_amount;
                        //that.getSalesbillentryDetailList();
                        that.clientStatus['hide_col'] = true;
                    }
                    if (that.clientStatus['tabParams'] == 'HV Appointment') {
                        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'HV');
                    }
                    else if (that.clientStatus['tabParams'] == 'SOA Appointment') {
                        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'SOA');
                    }
                }
                else {
                    if (that.clientStatus['tabParams'] == 'HV Appointment') {
                        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'HV');
                    }
                    else if (that.clientStatus['tabParams'] == 'SOA Appointment') {
                        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'SOA');
                    }
                }
            });
            // that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', that.clientStatus, 'Sales Bill');
            that.bsModalRef.hide();
        } else {
            if (this.clientStatus['followup_status'] == 25 && this.clientStatus['tabParams'] == 'HV Entry') {
                this.clientStatus['followup_status'] = 27;
            } else if (this.clientStatus['followup_status'] == 25 && this.clientStatus['tabParams'] == 'SOA Entry') {
                this.clientStatus['followup_status'] = 91;
            }

            this.isLoading = true;

            // Prepare data with image if uploaded
            let requestData: any;
            if (this.uploadedImageFile) {
                requestData = new FormData();
                // Add all clientStatus properties to FormData
                Object.keys(this.clientStatus).forEach(key => {
                    if (this.clientStatus[key] !== null && this.clientStatus[key] !== undefined) {
                        requestData.append(key, this.clientStatus[key]);
                    }
                });
                // Add the image file
                requestData.append('uploaded_image', this.uploadedImageFile);
            } else {
                requestData = this.clientStatus;
            }

            this.clientOutService
                .addClientOut(requestData)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');
                        that.bsModalRef.hide();
                        that.clientOutLoadEvent.emit();
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                });
        }
    }

    hasAssignFollowup(clientStatus) {
        return (clientStatus.followup_status == '5' || clientStatus.followup_status == '35');
    }

    searchEmployee(query: string) {
        this.searchTermsEmployee.next(query);
    }

    displayEmployeeFn(empID: number) {
        if (empID && this.employeeList && this.employeeList.length > 0) {
            // First try to find by empid, then by userid for compatibility
            let empObj = _.find(this.employeeList, { 'empid': empID }) || _.find(this.employeeList, { 'userid': empID });
            if (empObj) {
                return empObj['empname'] || empObj['fullname'];
            }
        }
        return '';
    }

    private prepareRequestData(): any {
        // Prepare data with image if uploaded
        let requestData: any = this.clientStatus
        if (this.uploadedImageFile) {
            // Add all clientStatus properties to FormData
            Object.keys(this.clientStatus).forEach(key => {
                if (this.clientStatus[key] !== null && this.clientStatus[key] !== undefined) {
                    const value = this.clientStatus[key];
                    // If value is an object or array, JSON.stringify it
                    if (typeof value === 'object') {
                        requestData.append(key, JSON.stringify(value));
                    } else {
                        requestData.append(key, String(value));
                    }
                }
            });
            // Add the image file
            requestData.append('uploaded_image', this.uploadedImageFile);
            return requestData;
        } else {
            return this.clientStatus;
        }
    }


}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/clientOut.component.ts